module.exports = __webpack_public_path__ + "fbfc9f94a89c94da866d0f25606d5436.fbx";